module.exports = {["template-constructor-control-common_layer"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon"data-alt="Arrange" data-alt-pos="left" data-alt-offset="9"></div>\n\n\n	<div class="panel">\n		<div class="backward-all" title="Send to Back"></div>\n		<div class="backward" title="Send Backward"></div>\n		<div class="forward" title="Bring Forward"></div>\n		<div class="forward-all" title="Send to Front"></div>\n	</div>\n';
}
return __p;
},}